import axios from "axios";
import React, { useEffect, useState } from "react";
import { FiPlus as Plus } from "react-icons/fi";
import { NotificationManager } from "react-notifications";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import DownArrow from "../../assets/svgs/down-arrow.svg";
import sortAsce from "../../assets/svgs/sort-ascending.svg";
import sortDesc from "../../assets/svgs/sort-descending.svg";
import swap from "../../assets/svgs/swap-vertical.svg";
import UpArrow from "../../assets/svgs/up-arrow.svg";
import Loader from "../../components/Loader";
import ContactPagination from "../../components/Pagination/ContactPagination";
import useAuth from "../../hooks/useAuth";
import { BASE_URL } from "../../utils/Element";
import { initialOfferFilterData } from "../../utils/initialData";
import ActionsMenu from "../ActionsMenu";
import DeleteConfirmationModal from "../ConfirmationModals/DeleteConfirmationModal";
import AddPortfolioModal from "./Modals/AddPortfolioModal";
import EditPortfolioModal from "./Modals/EditPortfolioModal";


const PortfolioTab = ({ from }) => {
  const { id } = useParams();
  const [config] = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [sortBy, setSortBy] = useState("id");
  const [loading, setLoading] = useState(true);
  const [portfolioData, setportfolioData] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});
  const [showEditModal, setShowEditModal] = useState(false)
  const [sortDirection, setSortDirection] = useState("asc");
  const isSidebarCollapsed = useSelector((state) => state.isSidebarCollapsed);
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [paginationData, setPaginationData] = useState({ totalItems: 0, from: 0, to: 0, totalPages: 0 });
  const [filterData, setFilterData] = useState(() => {
    const localFilterData = localStorage.getItem("filterData");
    return localFilterData ? JSON.parse(localFilterData) : initialOfferFilterData;
  });
  const queryParams = new URLSearchParams(location.search);
  const [search, setSearch] = useState(queryParams.get('search') ?? '');
  const [tabSearch, setTabSearch] = useState();
  const [disableDelete, setDisableDelete] = useState(false)

  const buildQueryParams = (filters) => {
    let params = `id=${id}&list_type=${from}&page=${currentPage}&per_page=${itemPerPage}`;

    const { associate, property_name, portfolio_name, description } = filters;

    if (associate) {
      params += `&broker=${encodeURIComponent(associate)}`;
    }
    if (property_name) {
      params += `&property_name=${encodeURIComponent(property_name)}`;
    }
    if (portfolio_name) {
      params += `&portfolio_name=${encodeURIComponent(portfolio_name)}`;
    }
    if (description) {
      params += `&description=${encodeURIComponent(description)}`;
    }
    if (sortDirection && sortBy !== "id") {
      params += `&sort_direction=${sortDirection}`;
    }
    if (sortBy !== "id") {
      params += `&sort_by=${sortBy}`;
    }
    if (tabSearch) {
      params += `&search=${tabSearch}`;
    }
    if (tabSearch) {
      params += `&search=${tabSearch}`;
    }

    return params;
  };

  const handleDelete = () => {
    setDisableDelete(true)
    axios
      .delete(`${BASE_URL}/delete-portfolio/${selectedId}`, config)
      .then((res) => {
        setSelectedId("")
        onSuccess()
        setShowDeleteModal(false)
        if (res?.data?.message) {
          NotificationManager.success(res?.data?.message)
        }
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message)
        }
      })
      .finally(() => setDisableDelete(false))
  }

  const fetchOffers = (filters) => {
    const queryParams = buildQueryParams(filters);
    axios
      .get(`${BASE_URL}/portfolio-list?${queryParams}`, config)
      .then((res) => {
        const value = res?.data;
        setportfolioData(value?.data?.data ?? []);
        setPaginationData({
          totalItems: value?.total ?? 0,
          from: value?.from ?? 0,
          to: value?.to ?? 0,
          totalPages: value?.last_page ?? 0,
        });
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchOffers(filterData);
  }, [sortDirection, sortBy, tabSearch]);

  useEffect(() => {
    onSuccess();
  }, [currentPage, itemPerPage]);

  const onSuccess = (filters) => {
    setLoading(true);
    if (filters) {
      fetchOffers(filters);
    } else {
      fetchOffers(filterData);
    }
  };

  const handleNext = () => {
    if (currentPage !== paginationData.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    if (queryParams) {
      queryParams.set('search', search);
    } else {
      queryParams.delete('search');
    }
    navigate({ search: queryParams.toString() }, { replace: true });
  }, [search, navigate, location.search]);

  const toggleRowDetails = (id) => {
    setExpandedRows((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <div>
      <div className="flex justify-between items-start head-5 green-H">

        <div className="search-box contacts">
          <input
            type="text"
            className="body-S"
            placeholder="Search Here..."
            value={tabSearch}
            onChange={(e) => {
              setTabSearch(e.target.value);
            }}
            style={{ border: "1px solid #D8D8D8", marginTop: "0px" }}
          />
        </div>

        <p
          className="head-5 green-H flex items-center gap-1"
          role="button"
          onClick={() => {
            setShowModal(true);
            setSelectedId("");
          }}
        >
          <Plus /> Add Portfolio
        </p>
      </div>

      <div className="light-bg-L pb-3 table-container">
        <div className={`${isSidebarCollapsed ? "tab-collapsed-width" : "tab-width"} table-info light-bg-L`}>
          {loading ? (
            <Loader />
          ) : portfolioData?.length === 0 ? (
            <p className="body-N text-center mt-6 p-5">No Portfolio Available</p>
          ) : (
            <table className="contact-table light-bg-L" style={{ width: "100%" }}>
              <thead>
                <tr className="uppercase body-N dark-M">

                  <th>
                    <div className="table-header">
                      Property Info
                    </div>
                  </th>

                  <th>
                    <div className="table-header">
                      Portfolio Name
                      <img
                        role="button"
                        src={sortBy !== "portfolio_name" ? swap : sortDirection === "desc" ? sortDesc : sortAsce}
                        alt="icon"
                        onClick={() => {
                          setSortBy("portfolio_name");
                          if (sortDirection === "desc") {
                            setSortDirection("asc");
                          } else {
                            setSortDirection("desc");
                          }
                        }}
                      />
                    </div>
                  </th>

                  <th>
                    <div className="table-header">
                      Description
                      <img
                        role="button"
                        src={sortBy !== "description" ? swap : sortDirection === "desc" ? sortDesc : sortAsce}
                        alt="icon"
                        onClick={() => {
                          setSortBy("description");
                          if (sortDirection === "desc") {
                            setSortDirection("asc");
                          } else {
                            setSortDirection("desc");
                          }
                        }}
                      />
                    </div>
                  </th>

                  <th>
                    <div className="table-header">More</div>
                  </th>

                </tr>
              </thead>
              <tbody>
                {Array.isArray(portfolioData) &&
                  portfolioData.map((el, idx) => (
                    <React.Fragment key={idx}>
                      {/* Parent row with name & description */}
                      <tr className="body-N dark-H">
                        <td>
                          <img
                            role="button"
                            src={expandedRows[el.id] ? UpArrow : DownArrow}
                            alt="icon"
                            className="sidebar-icons"
                            onClick={() => toggleRowDetails(el.id)}
                          />
                        </td>

                        <td className="capitalize head-5">{el?.name}</td>
                        <td className="capitalize head-5">{el?.description}</td>

                        <td className="flex gap-3 items-center w-full justify-center">
                          <ActionsMenu
                            handleEdit={() => {
                              setShowEditModal(true)
                              setSelectedId(el.id)
                            }}
                            handleDelete={() => {
                              setSelectedId(el?.id);
                              setShowDeleteModal(true);
                            }}
                          />
                        </td>
                      </tr>

                      {expandedRows[el.id] && (
                        <tr>
                          <td colSpan="11">
                            <div className="expanded-row-content p-4 bg-[rgb(244,244,244)] rounded-md">

                              <div className="grid grid-cols-4 gap-6 mb-4">
                                <label className="dark-H head-4 block">Property Name</label>
                                <label className="dark-H head-4 block">Owner Name</label>
                                <label className="dark-H head-4 block">Asking Price</label>
                                <label className="dark-H head-4 block">Asking Cap Rate</label>
                              </div>

                              {Array.isArray(el?.portfolois ?? el?.portfolios) &&
                                (el?.portfolois ?? el?.portfolios).map((pf, pfIdx) => (
                                  <div
                                    key={pfIdx}
                                    className="grid grid-cols-4 gap-6 mb-3 border-b border-gray-200 pb-3 last:border-b-0 last:pb-0"
                                  >
                                    <p className="body-N dark-H">
                                      <Link
                                        to={`/property/${pf.property_id}`}
                                        rel="noopener noreferrer"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          navigate(`/property/${pf.property_id}`);
                                        }}
                                      >
                                        {pf?.property?.property_name}
                                        <br />
                                        {[pf?.property?.city, pf?.property?.state].filter(Boolean).join(", ")}
                                      </Link>
                                    </p>

                                    <p className="body-N dark-H">
                                      <span className="green-H body-S">{pf?.property?.owner?.name}</span>
                                    </p>

                                    <p className="body-N dark-H">
                                      <span className="green-H body-S">${pf?.property?.asking_price_format}</span>
                                    </p>

                                    <p className="body-N dark-H">
                                      <span className="green-H body-S">{pf?.property?.asking_cap_rate_format}%</span>
                                    </p>
                                  </div>
                                ))}
                            </div>
                          </td>
                        </tr>
                      )}

                    </React.Fragment>
                  ))}
              </tbody>





            </table>
          )}
        </div>

        <ContactPagination
          paginationData={paginationData}
          handleNext={handleNext}
          handlePrev={handlePrev}
          onSuccess={onSuccess}
          itemPerPage={itemPerPage}
          handleItemPerPageSelect={(value) => {
            setItemPerPage(value);
            setCurrentPage(1);
          }}
        />
      </div>

      <DeleteConfirmationModal
        showModal={showDeleteModal}
        disable={disableDelete}
        onClose={() => setShowDeleteModal(false)}
        handleDelete={handleDelete}
      />

      <AddPortfolioModal
        showModal={showModal}
        onClose={() => setShowModal(false)}
        onCallApi={() => {
          setSelectedId("");
          onSuccess();
        }}
        from={from}
        id={id}
      />

      <EditPortfolioModal
        showModal={showEditModal}
        onClose={() => setShowEditModal(false)}
        from={from}
        onCallApi={() => {
          setSelectedId("")
          onSuccess()
        }}
        id={selectedId}
        parentId={id}
      />
    </div>
  );
};

export default PortfolioTab;
